export default (function (parent) {
  $(".space_top, .space_bottom").each(function () {
    if ($(this).parents(parent).length) {
      var $space_top, $space_top_ar, $ar_pad_top, $space_bottom, $space_bottom_ar, $ar_pad_bottom;
      $space_top = $(this).data("padding_top");

      if ($space_top) {
        $space_top_ar = $space_top.split("|");
        $ar_pad_top = [];

        for (var i = 0; i < 3; i++) {
          $ar_pad_top[i] = parseInt($space_top_ar[i]);
        }
      }

      $space_bottom = $(this).data("padding_bottom");

      if ($space_bottom) {
        $space_bottom_ar = $space_bottom.split("|");
        $ar_pad_bottom = [];

        for (var i = 0; i < 3; i++) {
          $ar_pad_bottom[i] = parseInt($space_bottom_ar[i]);
        }
      }

      if ($space_top && $space_top !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("padding-top", $ar_pad_top[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("padding-top", $ar_pad_top[1] + "px");
        } else {
          $(this).css("padding-top", $ar_pad_top[2] + "px");
        }
      }

      if ($space_bottom && $space_bottom !== '') {
        if (window.matchMedia('(min-width: 992px)').matches) {
          $(this).css("padding-bottom", $ar_pad_bottom[0] + "px");
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          $(this).css("padding-bottom", $ar_pad_bottom[1] + "px");
        } else {
          $(this).css("padding-bottom", $ar_pad_bottom[2] + "px");
        }
      }
    }
  });
  $(".helper-box_padding-top").each(function () {
    if ($(this).parents(parent).length) {
      var $padding_top;
      $padding_top = parseInt($(this).css("padding-top"));

      if ($padding_top && $padding_top !== 0) {
        $(this).find(".helper-box--padding-top").css('height', $padding_top + 'px');
      }
    }
  });
});